"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _server = _interopRequireDefault(require("react-dom/server"));

var _he = _interopRequireDefault(require("he"));

var _trimEllipsify = _interopRequireDefault(require("./trimEllipsify"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var reactToHtml = function reactToHtml(component) {
  return _he["default"].decode(_server["default"].renderToStaticMarkup(component));
};

var ExperimentIconDiv = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50%;\n  font-size: 16px;\n  height: 20px;\n  width: 20px;\n  text-align: center;\n  padding-top: 1px;\n  vertical-align: middle;\n  margin-right: 6px;\n  opacity: 0.4;\n  display: inline-block;\n"])), function (props) {
  return props.background;
}, function (props) {
  return props.color;
});

var YAxisLabel = function YAxisLabel(props) {
  var experimentIcon = props.experimentType === "PROTEOMICS_BASELINE" || props.experimentType === "PROTEOMICS_BASELINE_DIA" ? /*#__PURE__*/_react["default"].createElement(ExperimentIconDiv, {
    background: "green",
    color: "white",
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    title: "Proteomics experiment"
  }, "P") : props.experimentType && /*#__PURE__*/_react["default"].createElement(ExperimentIconDiv, {
    background: "orangered",
    color: "white",
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    title: "Transcriptomics experiment"
  }, "T");

  var geneNameWithLink = /*#__PURE__*/_react["default"].createElement("a", {
    href: props.config.outProxy + props.url,
    style: {
      border: "none",
      color: "#148ff3"
    }
  }, [experimentIcon, (0, _trimEllipsify["default"])(props.labelText, 40)]);

  return props.extra ? /*#__PURE__*/_react["default"].createElement("span", {
    title: props.labelText.length > 40 ? props.labelText : ""
  }, geneNameWithLink, /*#__PURE__*/_react["default"].createElement("em", {
    style: {
      color: "black"
    }
  }, "\t".concat(props.extra))) : /*#__PURE__*/_react["default"].createElement("span", {
    title: props.labelText.length > 40 ? props.labelText : ""
  }, geneNameWithLink);
};

YAxisLabel.propTypes = {
  config: _propTypes["default"].shape({
    atlasUrl: _propTypes["default"].string.isRequired,
    outProxy: _propTypes["default"].string.isRequired,
    isMultiExperiment: _propTypes["default"].bool.isRequired,
    isDifferential: _propTypes["default"].bool.isRequired,
    experiment: _propTypes["default"].shape({
      accession: _propTypes["default"].string.isRequired,
      type: _propTypes["default"].string.isRequired,
      description: _propTypes["default"].string.isRequired,
      species: _propTypes["default"].string.isRequired
    })
  }).isRequired,
  labelText: _propTypes["default"].string.isRequired,
  resourceId: _propTypes["default"].string.isRequired,
  url: _propTypes["default"].string.isRequired,
  extra: _propTypes["default"].string,
  experimentType: _propTypes["default"].string
};

var _default = function _default(config) {
  return {
    xAxisFormatter: function xAxisFormatter(value) {
      return value.label;
    },
    xAxisStyle: {
      fontSize: config.isDifferential ? "9px" : "smaller",
      cursor: "default",
      textOverflow: config.experiment ? "none" : "ellipsis",
      whiteSpace: config.isDifferential ? "normal" : "nowrap"
    },
    yAxisFormatter: function yAxisFormatter(value) {
      return reactToHtml( /*#__PURE__*/_react["default"].createElement(YAxisLabel, {
        config: config,
        labelText: value.label,
        resourceId: value.id,
        url: value.info.url,
        experimentType: value.info.experimentType,
        extra: value.info.designElement || ""
      }));
    },
    yAxisStyle: {
      fontSize: config.isMultiExperiment ? "smaller" : "small",
      color: "#148ff3"
    }
  };
};

exports["default"] = _default;